'use client';
var classes = {"root":"m_fea6bf1a","burger":"m_d4fb9cad"};

export { classes as default };
//# sourceMappingURL=Burger.module.css.mjs.map
